module.exports = __webpack_public_path__ + "static/assets/78d48375d26960c3ac4fe82387055621.svg";